import { TableCell, TableRow, Tooltip } from '@mui/material';
import { Icons, Images } from 'assets';
import classNames from 'classnames';
import styles from "pages/phNewPendingTasks/style.module.scss";
import { user_roles } from 'shared/utils/constants';


const SupportChat = () => {
    const tasksList = [
      {
        role: 1,
        status: 1,
      },
      {
        role: 2,
        status: 2,
      },
      {
        role: 3,
        status: 3,
      },
      {
        role: 4,
        status: 4,
      },
      {
        role: 5,
        status: 4,
      },
      {
        role: 6,
        status: 4,
      },
    ];
  
    return (
      <>
        {tasksList?.map((item: any, index: any, arr: any) => {
          return (
            <TableRow
            // className={classNames(index + 1 === arr.length && styles.lastCells)}
            >
              <TableCell>
                <div className={styles.nameCell}>
                  <img
                    src={Images.UserPlaceholderImage}
                    alt="profile_picture"
                    className={styles.profilepic}
                  />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label>Jane Doe</label>
                    <label className={styles.emailLabel}>janedoe@gmail.com</label>
                  </div>
                </div>
              </TableCell>
              <TableCell>
                {item?.role === user_roles.author
                  ? "Author"
                  : item?.role === user_roles.parent
                  ? "Parent"
                  : item?.role === user_roles.publisher
                  ? "Publisher"
                  : item?.role === user_roles.reader
                  ? "Reader"
                  : item?.role === user_roles.school
                  ? "School"
                  : item?.role === user_roles.teacher
                  ? "Teacher"
                  : ""}
              </TableCell>
              <TableCell className={styles.limitedCell}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
                reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </TableCell>
              <TableCell className={classNames(styles.statusCell)}>
                <label
                  className={
                    item?.status === 1
                      ? styles.approved
                      : item?.status === 2
                      ? styles.rejected
                      : item?.status === 3
                      ? styles.pending
                      : item?.status === 4
                      ? styles.neutral
                      : ""
                  }
                >
                  Status
                </label>
              </TableCell>
              <TableCell>2</TableCell>
              <TableCell>
                <div className={styles.actionContainer}>
                  <Tooltip arrow title="View Ticket">
                    <div>
                      <Icons.EyeIcon className={styles.icons} />
                    </div>
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </>
    );
  };

export default SupportChat
